// const link = 'http://localhost:8080'
const link='https://notes-backend-drab.vercel.app'

module.exports = link